import createClient, { type Client, type ClientOptions } from 'openapi-fetch';
import type { paths } from './generated/schema';
import { idempotencyKeys, versionHeaders } from './middleware';

export type PaigeClient = Client<paths>;

export interface PaigeClientOptions extends Omit<ClientOptions, 'baseUrl'> {
  /** e.g. `https://api.paige.app/v1` or `/v1` behind the same origin. */
  baseUrl: string;
  clientVersion: string;
  /** Override key minting (tests, or a caller that owns retry semantics). */
  newIdempotencyKey?: () => string;
}

/** A typed fetch client over the generated OpenAPI paths with the Paige middleware attached. */
export function createPaigeClient(opts: PaigeClientOptions): PaigeClient {
  const { clientVersion, newIdempotencyKey, ...rest } = opts;
  const client = createClient<paths>({ credentials: 'include', ...rest });
  client.use(versionHeaders({ clientVersion }));
  client.use(idempotencyKeys(newIdempotencyKey));
  return client;
}
